export class Enums {
    static ChatMode = {
        CHANNEL: 'channel',
        PRIVATE: 'private',
        GROUP: 'group',
    }

}
